const API_ROOT = {
  development: 'http://api-test.dokimoai.com',
  test: 'http://api-test.dokimoai.com',
  production: 'http://api.dokimoai.com',
}

const API_ROOT_COMMUNITYGOVERN = {
  development: 'http://test-shortvideo-api.szsttkj.com',
  test: 'http://test-shortvideo-api.szsttkj.com',
  // production: 'https://shortvideo-api.szsttkj.com',
  production: 'https://api-shortvideo-xc.szxlxzb.com',
}

const API_PREFIX = '/characterapi'

const API_PREFIX_COMMUNITYGOVERN = `${API_PREFIX}/communitygovern`

const proxyMatch = new RegExp(`^${API_PREFIX}`)

const proxyMatchCommunitygovern = new RegExp(`^${API_PREFIX_COMMUNITYGOVERN}`)

const roots2Proxies = (env) => [
  {
    match: proxyMatchCommunitygovern,
    map: (path) => path.replace(API_PREFIX_COMMUNITYGOVERN, '/communitygovern'),
    host: API_ROOT_COMMUNITYGOVERN[env],
  },
  {
    match: proxyMatch,
    map: (path) => path.replace(API_PREFIX, ''),
    host: API_ROOT[env],
  },
]

module.exports = {
  project: 'agi-h5',
  devPort: 7000,
  devStaticPort: 7001,
  production: {
    ENV: 'production',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
  API_ROOT,
  API_PREFIX,
  scriptsConfig: {
    // 禁止webpack 自动导入 antd-mobile的样式文件
    disableAutoImportAntdMobileCss: true,
  },
  babelInclude: [
    './src',
    './node_modules/react-vant',
    './node_modules/omni-lib',
    './node_modules/@react-spring',
    './node_modules/@use-gesture',
  ],
}
